<template>
    <div class="pageClass">
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        
        <NavBar></NavBar>

        <div class="form-steps">
            <!-- First Step -->
            <div class="form-steps__step form-steps__step--completed">
                <div class="form-steps__step-circle">
                <span class="form-steps__step-number">1</span>
                <span class="form-steps__step-check">&#x2713;</span>
                </div>
                <span class="form-step__step-name">選擇課程</span>
            </div>
            <!-- Second Step -->
            <div class="form-steps__step form-steps__step--active form-steps__step--last">
                <div class="form-steps__step-circle">
                <span class="form-steps__step-number">2</span>
                <span class="form-steps__step-check">&#x2713;</span>
                </div>
                <span class="form-step__step-name">選擇時間及老師</span>
            </div>
        </div>

        <span>{{LessonObject}}</span>

        <hr />
        <!-- 日期 -->
        <div class="p-2 d-flex justify-content-around">
            <div></div>
            <div>
                <span class="PickingDateSpan">日期：</span>
                <input type="date" id="start" name="trip-start" class="PickingDate" 
                    :min="MinSelectedDate" :max="MaxSelectedDate" 
                    v-model="selectedDate" @change="SearchTeacherForBooking()">
            </div>
            <div class="SearchTeacherNameDIV">
                <input type="test" placeholder="搜尋老師名字" class="SearchTeacherName" @change="SearchingTeacher" v-model="FilterName">
            </div>
        </div>
        <!--choosing teacher-->
        <div class="p-2 TeacherList" >
            <div v-for="Booking in BookingObject">
            <!--<div v-for="Booking in FilterBookingObject">-->
                <div>
                    <span>{{dateFormat(Booking.StartTimeStamp,1)}} - {{dateFormat(Booking.EndTimeStamp,1)}}</span>
                </div>

                <div class=" d-flex justify-content-between p-1 " v-for="bookingDetails in Booking.bookingDetails">
                    <div class="Teacher"  data-toggle="modal" data-target="#TeacherInfoModal" @click="OpenTeacherInfo(bookingDetails)">
                        <img :src="bookingDetails.TeacherPhoto" class="TeacherIMG">
                        <span>{{bookingDetails.TeacherName}}</span>
                    </div>
                    <button class="ShareBTN" data-toggle="modal" data-target="#ConfirmBookingModal" @click="BookingTeacher(bookingDetails)">立即訂課</button>
                </div>
            <hr/>
            </div>
            <span style="text-align: center; display:block;">{{NoTeacherNote}}</span>
        </div>
        <div class="p-2 footerNAV">
            <button class="ShareBTN">
                <router-link :to="`/BookingLesson`">上一步</router-link>
            </button>
        </div>

        <!-- ConfirmBookingModal -->        
        <div class="modal fade" id="ConfirmBookingModal" tabindex="-1" aria-labelledby="ConfirmBookingModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body ">
                        <div>
                            <span>課程：{{LessonObject}}</span><br/>
                            <span>訂課時間：{{dateFormat(SelectedTeacher.StartTimeStamp,0)}}</span><br/>
                            <span>授課老師：{{SelectedTeacher.TeacherName}}</span><br/>
                            <span>消耗：{{SelectedTeacher.Point}}</span><span v-if="SelectedTeacher.Point!=0">{{SelectedTeacher.PointUnit}}</span><br/>
                            <span>請確認是否要訂課</span>
                        </div>
                        <div class=" d-flex justify-content-end ">
                            <button type="button" class="ShareBTN m-1" data-dismiss="modal">取消</button>
                            <button type="button" class="ShareBTN m-1" @click="StudentBooking()" data-dismiss="modal">確認</button>
                        </div>
                    </div>
                    <div class="modal-footer">
                    </div>
                </div>
            </div>
        </div>

        
        <!-- TeacherInfoModal -->        
        <div class="modal fade" id="TeacherInfoModal" tabindex="-1" aria-labelledby="TeacherInfoModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                    <h5>{{TeacherInfoObjects.TeacherName}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="PauseTeacherVoice()">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body ">
                        <div class=" InfoTop">
                            <div class="">
                                <img :src="TeacherInfoObjects.TeacherPhoto" class="TeacherInfoIMG">
                            </div>
                        </div>
                        <div class="LessonDetailTable">
                            <div class="d-flex p-2 align-self-start">
                                <div class="TeacherInfoSubTitle">
                                    教學年資
                                </div>
                                <div class="ml-2">{{TeacherInfoObjects.ExpYear}}
                                </div>
                            </div>
                            <div class="d-flex p-2">
                                <div class="TeacherInfoSubTitle">
                                    適合學員
                                </div>
                                <div class="ml-2">
                                    <span v-for="(LevelList,index) in TeacherInfoObjects.TeachingLevelList">
                                        {{LevelList}}
                                    </span>
                                </div>
                            </div>
                            <div class="d-flex p-2">
                                <div class="TeacherInfoSubTitle">
                                    教學風格
                                </div>
                                <div class="ml-2 flex-shrink-1">
                                    <span v-for="(StyleList,index) in TeacherInfoObjects.TeacherStyleList">
                                        {{StyleList}}
                                    </span>
                                </div>
                            </div>
                            <div class="d-flex p-2">
                                <div class="TeacherInfoSubTitle">
                                    教學背景
                                </div>
                                <div class="ml-2">
                                    <span v-html="TeacherInfoObjects.TeachingBackground"></span>
                                </div>
                            </div>
                            <div class="d-flex p-2">
                                <div class="TeacherInfoSubTitle">
                                    證照證書
                                </div>
                                <div class="ml-2">
                                    <span v-html="TeacherInfoObjects.Certificate"></span>
                                </div>
                            </div>
                            <div class="d-flex p-2">
                                <div class="TeacherInfoSubTitle">
                                    教師介紹
                                </div>
                                <div class="ml-2">
                                    <button class="ShareBTN" @click="PlayTeacherVoice(TeacherInfoObjects.TeacherVoice)">撥放音檔</button>
                                    <button class="ShareBTN" @click="PauseTeacherVoice()">暫停音檔</button>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div>
                            <span v-html="TeacherInfoObjects.TeacherSelfIntro"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import axios from 'axios'
import moment from 'moment'
import Vue from 'vue'
export default {
    name: 'BookingTeacher',
    components:{
        NavBar
    },
    data () {
        return {
            LessonObject:{},
            BookingObject:[],
            SelectedTeacher:{},
            TeacherInfoObjects:{},
            Token:'',
            selectedDate:moment(new Date()).format('yyyy-MM-DD'),
            MinSelectedDate:moment(new Date()).format('yyyy-MM-DD'),
            MaxSelectedDate:moment(new Date()).add(14, 'days').format('yyyy-MM-DD'),
            NoTeacherNote:'',
            showLoading:false,
            TeacherVoice:'',
            FilterName:'',
            BKBookingObject:[]
        }
    },
    created(){
        this.Token = sessionStorage.getItem('Token');
        this.LessonObject = this.$route.params.Lesson;
        // console.log(this.LessonObject);
        this.SearchTeacherForBooking();
    },
    methods:{
        BookingTeacher(BookingTimeItem){
            // console.log(BookingTimeItem);
            this.SelectedTeacher = BookingTimeItem;
        },
        OpenTeacherInfo(Booking){
            this.SelectedTeacher = Booking;
            this.GetTeacherInformation();
        },
        dateFormat(timestamp,type){
            if(timestamp && timestamp != "")
            {
                if(type == 0){
                    return moment.unix(timestamp).format("yyyy-MM-DD HH:mm:ss");
                }else{
                    return moment.unix(timestamp).format("HH:mm");
                }
            }
            return "";
        },

        PlayTeacherVoice(TeacherVoiceURL){
            this.TeacherVoice = new Audio(TeacherVoiceURL);
            this.TeacherVoice.play();
        },
        PauseTeacherVoice(){
            if(this.TeacherVoice != ""){
                this.TeacherVoice.pause();
                this.TeacherVoice = "";
            }
        },
        SearchingTeacher:function(){
            if(this.FilterName != ""){
                var bookingDetail = [];
                this.BookingObject = [];

                this.BKBookingObject.forEach(ItemObjects => {
                    bookingDetail =  ItemObjects.bookingDetails.filter(teacher=>{
                        return teacher.TeacherName.toLowerCase().includes(this.FilterName.toLowerCase());
                    })
                    if(bookingDetail.length > 0){
                        this.BookingObject.push({
                            EndTimeStamp:ItemObjects.EndTimeStamp,
                            StartTimeStamp:ItemObjects.StartTimeStamp,
                            bookingDetails:bookingDetail
                        })
                    }
                })
            }else{
                this.BookingObject = this.BKBookingObject;
            }
        },
        //取得可訂課老師時間清單
        SearchTeacherForBooking(){
            this.showLoading = true;
            this.BookingObject = [];
            this.NoTeacherNote = '';
            // console.log(this.selectedDate);
            const api =`${process.env.APIPATH}/api/Student/SearchTeacherByLessonName`;
            // const api =`${process.env.APIPATH}/api/Student/SearchTeacherForBooking`;
            const headers = {"Authorization": 'Bearer '+this.Token};
            const inputdata = 
            {
                "LessonName": this.LessonObject,
                // "LessonId": this.LessonObject.LessonId,
                "StartTimeStamp":moment(this.selectedDate, 'yyyy-MM-DD HH:mm:ss').format("X"),
                "EndTimeStamp":moment(this.selectedDate, 'yyyy-MM-DD HH:mm:ss').add(1, 'days').format("X")
            };

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.Result){
                        if(response.data.BookingTimeItemObjects == undefined || response.data.BookingTimeItemObjects.length == 0){
                            this.NoTeacherNote ='此時段無教師可選擇！';
                            this.BookingObject = [];
                        }else{
                            this.BKBookingObject = response.data.BookingTimeItemObjects;
                            this.BookingObject = response.data.BookingTimeItemObjects;
                        }
                    }else{
                        if(response.data.errorCode == 20002){
                            alert("閒置時間過長，請重新進入。");
                        }
                        this.NoTeacherNote ='此時段無教師可選擇！';
                        this.BookingObject = [];
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert("可訂課教師取得失敗："+ error.message);
                });
        },

        //訂課
        StudentBooking(){
            this.showLoading = true;
            /*if(sessionStorage.getItem('CustomerCode') == '1110'){
                var api =`${process.env.APIPATH}/api/Jeda/Booking`;
            }else{*/
                var api =`${process.env.APIPATH}/api/Student/StudentBooking`;
            //}
            const headers = {"Authorization": 'Bearer '+this.Token};
            const inputdata = 
            {
                // "LessonId": this.LessonObject.LessonId,
                "LessonId": this.SelectedTeacher.LessonId,
                "TeacherId": this.SelectedTeacher.TeacherId,
                "BookingTimeStamp": this.SelectedTeacher.StartTimeStamp,
            };

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.Result){
                        alert("訂課成功！");
                        this.$router.push({name: 'Home'});
                    }else{
                        if(response.data.errorCode == 20002){
                            alert("閒置時間過長，請重新進入。");
                        }else{
                            alert("訂課失敗："+response.data.Message);
                        }
                        this.SearchTeacherForBooking();
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert("訂課失敗："+ error.message);
                });
        },

        //取得老師介紹
        GetTeacherInformation(){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Student/GetTeacherInformation`;
            const headers = {"Authorization": 'Bearer '+this.Token};
            const inputdata = 
            {
                "TeacherId": this.SelectedTeacher.TeacherId,
            };

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.Result){
                        this.TeacherInfoObjects = response.data.TeacherInfoObjects;
                    }else{
                        if(response.data.errorCode == 20002){
                            alert("閒置時間過長，請重新進入。");
                        }else{
                            alert(response.data.Message);
                        }
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert("教師介紹取得失敗："+ error.message);
                });
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/components/pages/BookingTeacher.vue